/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_SyncedInputs */

const cs_projects_synced = /** @type {(inputs: Projects_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizováno`)
};

const en_projects_synced = /** @type {(inputs: Projects_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synced`)
};

/**
* | output |
* | --- |
* | "Synced" |
*
* @param {Projects_SyncedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_synced = /** @type {((inputs?: Projects_SyncedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_SyncedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_synced(inputs)
	return cs_projects_synced(inputs)
});